import { z } from 'zod'
import { UTCMillisecondsSchema } from '../time'
import { apiRequest, emptyApiRequest } from '../api'
import { NotificationTopicSchema, NotificationViewSchema } from './model'

export const NotificationListInputSchema = apiRequest({
  view: NotificationViewSchema.default('inbox'),
  topic: NotificationTopicSchema.optional(),
  cursor: z.string().min(1).optional(),
  limit: z.number().int().min(1).max(50).default(20),
}).strict()
export const NotificationUnreadCountInputSchema = emptyApiRequest().strict()

// Operations validate ID syntax so malformed IDs return NotFound, not InvalidRequest.
const NotificationReadIdsInputSchema = apiRequest({
  ids: z.string().array().min(1).max(100),
  read: z.boolean(),
  all: z.undefined().optional(),
}).strict()
export const NotificationReadAllInputSchema = apiRequest({
  all: z.literal(true),
  before: UTCMillisecondsSchema,
  topic: NotificationTopicSchema.optional(),
  cursor: z
    .string()
    .min(1)
    .max(1024)
    .optional()
    .describe('nextCursor from the previous read-all response with the same before and topic.'),
  read: z.literal(true),
}).strict()
// Strict branches keep ID and all modes exclusive in both Zod and OpenAPI.
export const NotificationReadInputSchema = z.discriminatedUnion('all', [
  NotificationReadIdsInputSchema,
  NotificationReadAllInputSchema,
])
export const NotificationArchiveInputSchema = apiRequest({
  ids: z.string().array().min(1).max(100),
  archived: z.boolean(),
}).strict()
export type NotificationListInput = z.infer<typeof NotificationListInputSchema>
export type NotificationUnreadCountInput = z.infer<typeof NotificationUnreadCountInputSchema>
export type NotificationReadAllInput = z.infer<typeof NotificationReadAllInputSchema>
export type NotificationReadInput = z.infer<typeof NotificationReadInputSchema>
export type NotificationArchiveInput = z.infer<typeof NotificationArchiveInputSchema>
